import React, { useState } from "react";
import NativeSelect from "@material-ui/core/NativeSelect";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Radio from "@material-ui/core/Radio";
import Grid from "@material-ui/core/Grid";
import MediaCard from "./selectedCard";
import Dialog from "@material-ui/core/Dialog";
import { useForm } from "react-hook-form";
import { Checkbox, Tooltip } from "@material-ui/core";
import axios from 'axios';

const apiToken = "owiejfoiwhjef;iuhnaergfbm,cvnbioedrg";

const addressesMatch = (addressOne, addressTwo) => {
  return addressOne.street1 == addressTwo.street1 && addressOne.street2 == addressTwo.street2 && addressOne.city == addressTwo.city && addressOne.zip == addressTwo.zip;
}

const PatientName = (props) => {
  return props.patientNameToggle === "Yes" ? (
    <Grid item sm={6}>
      <TextField
        fullWidth
        id="patient-name"
        name="patient_name"
        label="What is their name?"
        variant="outlined"
        // inputRef={props.register({
        //   required: props.patientNameToggle === "Yes",
        //   maxLength: 20,
        // })}
        inputProps={{maxLength: 64}}
      />
    </Grid>
  ) : null;
};
const BillingForm = (props) => {
  return props.billingAddressToggle === "No" ? (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">Billing Address</Typography>
      </Grid>
      <Grid item sm={6}>
        <TextField
          fullWidth
          id="first-name-billing"
          name="first_name_billing"
          label="First Name"
          variant="outlined"
          // inputRef={props.register({
          //   required: props.billingAddressToggle === "No",
          //   maxLength: 64,
          // })}
          inputProps={{maxLength: 64}}
        />
      </Grid>
      <Grid item sm={6}>
        <TextField
          fullWidth
          id="last-name-billing"
          name="last_name_billing"
          label="Last Name"
          variant="outlined"
          // inputRef={props.register({
          //   required: props.billingAddressToggle === "No",
          //   maxLength: 64,
          // })}
          inputProps={{maxLength: 64}}
        />
      </Grid>
      <Grid item sm={5}>
        <TextField
          fullWidth
          id="address-1-billing"
          name="address_1_billing"
          label="Address Line 1"
          variant="outlined"
          inputRef={props.register({
            required: props.billingAddressToggle === "No",
          })}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          fullWidth
          id="address-2-billing"
          name="address_2_billing"
          label="Address Line 2 (Apt, Ste, Room)"
          variant="outlined"
          inputRef={props.register()}
        />
      </Grid>
      <Grid item sm={3}>
        <TextField
          fullWidth
          id="city-billing"
          name="city_billing"
          label="City"
          variant="outlined"
          inputRef={props.register({
            required: props.billingAddressToggle === "No",
          })}
        />
      </Grid>
      <Grid item sm={2}>
        <NativeSelect
          fullWidth
          id="state-billing"
          name="state_billing"
          label="State"
          variant="outlined"
          inputRef={props.register({
            required: props.billingAddressToggle === "No",
          })}
        >
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="DC">District Of Columbia</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="RI">Rhode Island</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
        </NativeSelect>
      </Grid>
      <Grid item sm={2}>
        <TextField
          fullWidth
          id="zip-billing"
          name="zip_billing"
          label="Zip Code"
          variant="outlined"
          inputRef={props.register({
            required: props.billingAddressToggle === "No",
            minLength: 4,
            maxLength: 6,
          })}
        />
      </Grid>
    </Grid>
  ) : null;
};

const ErrorModal = (props) => {
  const handleYes = (candidate) => {
    props.setNewAddressValues(candidate);
  };
  const handleOverride = () => {
    props.setAddressValidationOverride(true);
  };
  if (props.addressValidationOverride) {
    return null;
  } else {
    return (
      <Dialog
        open={props.open}
        PaperProps={{ style: { margin: 0, padding: "12px" } }}
      >
        <Grid container>
          <Grid item container xs={12}>
            <Typography variant="h4">{props.title}</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginTop: "20px", marginBottom: "20px" }}
          >
            <Typography variant="h5">{props.body}</Typography>
          </Grid>
          {props.addressTries >= 2 && true && (
            <Grid item xs={12} style={{ marginBottom: "20px" }}>
              <Typography variant="h5">
                If you're having trouble, call us at 
                <a href="tel:470-800-9909">(470) 800-9909</a> and we would be
                happy to help you start your rehab.
              </Typography>
            </Grid>
          )}
          {props.errorType === "fuzzyMatch" ? (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  onClick={() => {
                    handleYes(props.addressCandidate);
                    props.setOpen(false);
                  }}
                  style={{ background: "#464d7c" }}
                  size="large"
                  variant="contained"
                  color="primary"
                  disableElevation
                  fullWidth
                >
                  Yes, use this address.
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={() => props.setOpen(false)}
                  style={{ background: "#666666" }}
                  size="large"
                  variant="contained"
                  color="secondary"
                  disableElevation
                  fullWidth
                >
                  No, I'll check again.
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  onClick={() => {
                    handleOverride();
                    props.setOpen(false);
                  }}
                  style={
                    props.addressTries < 2
                      ? { background: "#464d7c", display: "none" }
                      : { background: "#464d7c" }
                  }
                  disabled={props.addressTries < 2}
                  size="large"
                  variant="contained"
                  color="primary"
                  disableElevation
                  fullWidth
                >
                  I'm sure my address is correct.
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container direction="column" spacing={2}>
              <Grid item xs={12}>
                <Button
                  onClick={() => props.setOpen(false)}
                  style={{ marginBottom: "20px", background: "#464d7c" }}
                  size="large"
                  variant="contained"
                  color="primary"
                  disableElevation
                  fullWidth
                >
                  I'll check again.
                </Button>
                <Grid item xs={12}>
                  <Button
                    onClick={() => {
                      handleOverride();
                      props.setOpen(false);
                    }}
                    style={
                      props.addressTries < 2
                        ? { background: "#464d7c", display: "none" }
                        : { background: "#464d7c" }
                    }
                    disabled={props.addressTries < 2}
                    size="large"
                    variant="contained"
                    color="primary"
                    disableElevation
                    fullWidth
                  >
                    I'm sure my address is correct.
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Dialog>
    );
  }
};
export default function CustomerForm(props) {
  // eslint-disable-next-line no-unused-vars
  const { register, errors, handleSubmit, getValues, setValue } = useForm({
    shouldUnregister: false,
  });
  const [patientNameToggle, setPatientNameToggle] = useState("No");
  const [billingAddressToggle, setBillingAddressToggle] = useState("Yes");
  const [privacyPolicyToggle, setPrivacyPolicyToggle] = useState(false);
  const [showPrivacyTooltip, setShowPrivacyTooltip] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addressTries, setAddressTries] = useState(0);
  const [addressBody, setAddressBody] = useState("");
  const [addressTitle, setAddressTitle] = useState("");
  const [addressErrorType, setAddressErrorType] = useState("");
  const [addressCandidate, setAddressCandidate] = useState({});
  const [showPhoneError, setShowPhoneError] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);
  // const [addressValidated, setAddressValidated] = useState(false);
  const [addressValidationOverride, setAddressValidationOverride] = useState(
    false
  );
  const onSubmit = (data) => {
    // Validate phone and email format
    if (!/^(\d{9,20})$/.test(data.phone)) {
      setShowPhoneError(true);
      return;
    }

    if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(data.email)) {
      setShowEmailError(true);
      return;
    }
    props.onSubmit(data);
    props.handleFormChange("payment");
  };
  const onError = (errors) => {
    console.log(errors);
  };
  const radioChange = (event) => {
    setBillingAddressToggle(event.target.value);
  };
  const patientNameChange = (event) => {
    setPatientNameToggle(event.target.value);
  };
  const privacyPolicyChange = (event) => {
    setPrivacyPolicyToggle(event.target.checked);
    if (event.target.checked) {
      setShowPrivacyTooltip(false);
    }
  };
  const checkPrivacy = () => {
    if (!privacyPolicyToggle) {
      setShowPrivacyTooltip(true);
    }
  };
  const setNewAddressValues = (candidate) => {
    setValue("address_1", candidate.street1);
    setValue("address_2", candidate.street2);
    setValue("city", candidate.city);
    setValue("state", candidate.state);
    setValue("zip", candidate.zip);
  };

  const validateAddress = async (data) => {
    if (addressValidationOverride) {
      return true;
    } else {
      
      const postAddress = {
        street1: data.address_1,
        street2: data.address_2,
        city: data.city,
        state: data.state,
        zip: data.zip,
        country: "US"
      };
      
      const response = await axios.post('https://two.motusnova.com/postal/verifyAddress', {
        address: postAddress,
        token: apiToken,
      })
      const lookupResult = response.data;
      let addressValidated = false;
      try {
        if (lookupResult.dpv_confirmation === "Y") {
          if (!addressesMatch(postAddress, lookupResult) || lookupResult.dpv_footnotes !== "AABB") {
            if (lookupResult.street1.length > 0) {
              // give a 'did you mean'
              setAddressTries(addressTries + 1);
              setAddressTitle("Did you mean to enter this address?");
              setAddressBody(
                `${lookupResult.street1} ${lookupResult.street2 !== undefined
                  ? "\n" + lookupResult.street2
                  : ""
                } ${lookupResult.city}, ${lookupResult.state} ${lookupResult.zip}`
              );
              setAddressCandidate(lookupResult);
              setAddressErrorType("fuzzyMatch");
              setShowModal(true);
            } else {
              setAddressTries(addressTries + 1);
              setAddressTitle("We could not find your address.");
              setAddressBody("Please check that you've entered it correctly.");
              setAddressErrorType("generic");
              setShowModal(true);
            }
          } else {
            console.log("Address is good.");
            addressValidated = true;
          }
        } else if (lookupResult.dpv_confirmation === "S") {
          setAddressTries(addressTries + 1);
          setAddressTitle("We could not find your address.");
          setAddressBody(
            "It appears that your address is incomplete or incorrectly entered. The Address Line 1 is present in the USPS data, but the submitted Address Line 2 (apartment, suite, etc.) was not recognized."
          );
          setAddressErrorType("generic");
          setShowModal(true);
        } else {
          setAddressTries(addressTries + 1);
          setAddressTitle("We could not find your address.");
          setAddressBody("Please check that you've entered it correctly.");
          setAddressErrorType("generic");
          setShowModal(true);
        }
      } catch (err) {
        console.log(err);
      }
      if (addressValidated || addressValidationOverride) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <button
        type="submit"
        disabled
        style={{ display: "none" }}
        aria-hidden="true"
      ></button>
      <Grid container spacing={2}>
        <Grid
          item
          container
          xs={12}
          justify="center"
          style={{ marginTop: "30px" }}
        >
          <MediaCard
            peripheralType={props.deviceSelection.data.peripheral_type}
            telehealth={props.deviceSelection.data.telehealth}
            handleFormChange={props.handleFormChange}
            handleDeviceSelect={props.handleDeviceSelect}
          />
        </Grid>
        <ErrorModal
          open={showModal}
          setOpen={setShowModal}
          body={addressBody}
          title={addressTitle}
          addressTries={addressTries}
          errorType={addressErrorType}
          addressCandidate={addressCandidate}
          setNewAddressValues={setNewAddressValues}
          addressValidationOverride={addressValidationOverride}
          setAddressValidationOverride={setAddressValidationOverride}
        />
        <Grid item xs={12}>
          <Typography variant="h5">Shipping Address</Typography>
        </Grid>
        <Grid item sm={6}>
          <TextField
            fullWidth
            id="first-name"
            name="first_name"
            label="First Name"
            variant="outlined"
            inputRef={register({ required: true })}
            inputProps={{maxLength: 64}}
          />
        </Grid>
        <Grid item sm={6}>
          <TextField
            fullWidth
            id="last-name"
            name="last_name"
            label="Last Name"
            variant="outlined"
            inputRef={register({ required: true })}
            inputProps={{maxLength: 64}}
          />
        </Grid>
        <Grid item sm={5}>
          <TextField
            fullWidth
            id="address-1"
            name="address_1"
            label="Address Line 1"
            variant="outlined"
            inputRef={register({ required: true })}
          />
        </Grid>
        <Grid item sm={4}>
          <TextField
            fullWidth
            id="address-2"
            name="address_2"
            label="Address Line 2 (Apt, Ste, Room)"
            variant="outlined"
            inputRef={register()}
          />
        </Grid>
        <Grid item sm={3}>
          <TextField
            fullWidth
            id="city"
            name="city"
            label="City"
            variant="outlined"
            inputRef={register({ required: true })}
          />
        </Grid>
        <Grid item sm={2}>
          <InputLabel id="state">State</InputLabel>
          <NativeSelect
            fullWidth
            id="state"
            name="state"
            label="State"
            labelid="state"
            variant="outlined"
            inputRef={register({ required: true })}
          >
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </NativeSelect>
        </Grid>
        <Grid item sm={2}>
          <TextField
            fullWidth
            id="zip"
            name="zip"
            label="Zip Code"
            variant="outlined"
            inputRef={register({
              required: true,
              minLength: 4,
              maxLength: 6,
              validate: async () =>
                validateAddress(
                  getValues(["address_1", "address_2", "city", "state", "zip"])
                ),
            })}
          />
        </Grid>
        <Grid item sm={2}>
        <TextField
            fullWidth
            id="phone"
            name="phone"
            label="Phone"
            variant="outlined"
            inputRef={register({
              required: true,
              maxLength: 20,
            })}
            error={showPhoneError}
            helperText={showPhoneError ? "Invalid phone format" : ""}
            onFocus={() => setShowPhoneError(false)}
            onChange={(e) => {
              e.target.value = e.target.value.replace(/\D/g, '');
            }}
          />
        </Grid>
        <Grid item sm={3}>
          <TextField
            fullWidth
            id="email"
            name="email"
            label="Email"
            variant="outlined"
            inputRef={register({
              required: true,
            })}
            error={showEmailError}
            helperText={showEmailError ? "Invalid email format" : ""}
            onFocus={() => setShowEmailError(false)}
          />
        </Grid>
        <Grid item sm={3}>
          <InputLabel id="leadSource">Where did you hear about us?</InputLabel>
          <NativeSelect
            fullWidth
            id="leadSource"
            name="leadSource"
            label="Where did you hear about us?"
            labelid="leadSource"
            variant="outlined"
            inputRef={register({ required: true })}
          >
            <option value="other">Other</option>
            <option value="facebook">Facebook</option>
            <option value="google">Google</option>
            <option value="instagram">Instagram</option>
            <option value="youtube">YouTube</option>
            <option value="blogs">Blogs</option>
            <option value="referral">Referral</option>
          </NativeSelect>
        </Grid>
      </Grid>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Typography variant="h6">
            Is this subscription for yourself or for someone else?
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="row" spacing={0}>
            <Grid item sm={6}>
              <Radio
                color="#464d7c"
                checked={patientNameToggle === "No"}
                onChange={patientNameChange}
                value="No"
                id="nopatientname"
                name="patient_name_toggle"
                inputProps={{ "aria-label": "No" }}
                inputRef={register()}
              />
              <label for="nopatientname">
                <Typography variant="caption">Myself</Typography>
              </label>
            </Grid>
            <Grid item sm={6}>
              <Radio
                color="#464d7c"
                checked={patientNameToggle === "Yes"}
                onChange={patientNameChange}
                label={"Yes"}
                value="Yes"
                id="yespatientname"
                name="patient_name_toggle"
                inputProps={{ "aria-label": "Yes" }}
                inputRef={register({ required: true })}
              />
              <label for="yespatientname">
                <Typography variant="caption">Someone Else</Typography>
              </label>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <PatientName register={register} patientNameToggle={patientNameToggle} />
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Typography variant="h6">
            Is your billing address the same as your shipping address?
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="row" spacing={0}>
            <Grid item sm={6}>
              <Radio
                color="#464d7c"
                checked={billingAddressToggle === "Yes"}
                onChange={radioChange}
                label={"Yes"}
                value="Yes"
                name="billing_address_toggle"
                id="yesbilling"
                inputProps={{ "aria-label": "Yes" }}
                inputRef={register()}
              />
              <label for="yesbilling">
                <Typography variant="caption">Yes</Typography>
              </label>
            </Grid>
            <Grid item sm={6}>
              <Radio
                color="#464d7c"
                checked={billingAddressToggle === "No"}
                onChange={radioChange}
                value="No"
                id="nobilling"
                name="billing_address_toggle"
                inputProps={{ "aria-label": "No" }}
                inputRef={register()}
              />
              <label for="nobilling">
                <Typography variant="caption">No</Typography>
              </label>
            </Grid>
          </Grid>
        </Grid>
        <BillingForm
          register={register}
          billingAddressToggle={billingAddressToggle}
        />
        <Grid
          container
          spacing={0}
          style={{ paddingTop: 30, paddingBottom: 40 }}
        >
          <Grid container spacing={0} item xs={1} justify="center">
            <Grid item sm={6}>
              <Tooltip
                arrow
                placement="top"
                open={showPrivacyTooltip}
                title={
                  <>
                    <Typography variant="body1">
                      You must consent to the privacy policy before continuing.
                    </Typography>
                  </>
                }
                style={{ transform: "scale(1.3)" }}
              >
                <Checkbox
                  color="#464d7c"
                  checked={privacyPolicyToggle}
                  onChange={privacyPolicyChange}
                  name="billing_address_toggle"
                  inputProps={{ "aria-label": "Yes" }}
                />
              </Tooltip>
            </Grid>
          </Grid>
          <Grid item xs={11}>
            <Typography variant="h6">
              I consent to my personal data being used to process my order,
              support my experience throughout this website, and for other
              purposes as described in the Motus Nova{" "}
              <a
                href="https://motusnova.com/terms"
                target="_blank"
                className="link"
                rel="noopener noreferrer"
              >
                <u>terms and conditions</u>
              </a>
              .
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={12} spacing={2} container>
          <Grid item xs={6}>
            <Button
              style={{ background: "#666666" }}
              id="return"
              type="back"
              name="back"
              label="Back"
              size="large"
              variant="contained"
              color="secondary"
              disableElevation
              fullWidth
              onClick={() => {
                props.handleFormChange("deviceselect");
              }}
            >
              Back
            </Button>
          </Grid>
          <Grid
            item
            xs={6}
            onClick={() => {
              checkPrivacy();
            }}
          >
            <Button
              style={{ background: "#464d7c" }}
              disabled={!privacyPolicyToggle}
              id="submit"
              type="submit"
              name="submit"
              label="Submit"
              size="large"
              variant="contained"
              color="primary"
              disableElevation
              fullWidth
            >
              Next
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
